import React, { useState } from 'react';
import { Tab, Tabs } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { StatusFilter } from './constant';

const StatusTab = (props) => {
  const [value, setValue] = useState('Inventory');

  const AntTabs = withStyles({
    root: {
      borderBottom: '1px solid #e8e8e8',
    },
    indicator: {
      backgroundColor: '#389203',
    },
  })(Tabs);

  const AntTab = withStyles((theme) => ({
    root: {
      textTransform: 'none',
      minWidth: 72,
      marginRight: theme.spacing(4),
      '&:hover': {
        color: '#389203',
        opacity: 1,
      },
      '&$selected': {
        color: '#389203',
      },
      '&:focus': {
        color: '#389203',
        outline: 'none',
      },
      '& button:focus': {
        outline: 'none',
      },
      fontSize: theme.typography.pxToRem(15),
    },
  }))((props) => <Tab disableRipple {...props} />);

  const handleChange = (event, newValue) => {
    setValue(newValue);
    props.handleStatusChange(newValue)
  };

  return <React.Fragment>
    <AntTabs value={props.status} onChange={handleChange}  >
      {
        StatusFilter.map((item, index) => {
          return <AntTab key={index} value={item.value} label={item.status} wrapped />
        })
      }
    </AntTabs>
  </React.Fragment>
}

export default StatusTab;